<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      .form-inline
        .form-group.m5(kz-restrict="ROLE_ORGANIZATION_ADMIN")
          label Show deleted:
          input.deleted(type="checkbox" v-model="showDeleted")
          | &nbsp;
        .form-group
          input.form-control(type="text" placeholder="User filter" v-model="filter" @input="onFilter($event.target.value)")
          | &nbsp;
        .form-group
          router-link.btn.btn-primary.new-user-button(:to="{name: 'userNew'}")
            i.glyphicon.glyphicon-plus
            span.ml5 New User

    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Name
        th Email
        th Default Group
        th Status
        th
      tr(v-for="u in users")
        td {{u.username}}
        td {{u.email}}
        td {{u.defaultGroup.name}}
        td.actions
          .label.label-danger(v-show="!u.enabled") disabled
          .label.label-danger(v-show="u.credentialsExpired") credentials expired
          .label.label-danger(v-show="u.locked") locked
            | &nbsp;
            i.fa.fa-lock
        td.actions
          router-link.btn-view(:to="{name: 'user', params: {id: u.id}}" title="View") View
          router-link.btn-edit(:to="{name: 'userEdit', params: {id: u.id}}" title="Edit")
          a.btn-restore(title="Restore user" @click="undelete(u.id)" v-if="u.deleted")
</template>

<script>
import miniToastr from 'mini-toastr'
import debounce from 'debounce'
import DataGrid from '@/components/ssp/DataGrid'
import Security from '@/service/apis/Security'

export default {
  data: () => ({
    showDeleted: false,
    filter: null,
    users: []
  }),
  created() {
    this.onFilter = debounce(this.onFilter, 200)
  },
  watch: {
    showDeleted() {
      this.$refs.grid.reload()
    }
  },
  methods: {
    onFilter() {
      this.$refs.grid.reload()
    },
    undelete(id) {
      this.$confirm({ text: 'Are you sure you want to un-delete this user?' })
        .then((conf) => {
          if (conf) {
            Security.undeleteUser(id)
              .then(() => {
                miniToastr.success('User was undeleted')
                this.$refs.grid.reload()
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    },
    fetchData(page) {
      const req = page.pageRequest()
      req.filter = this.filter
      if (this.showDeleted) {
        req.deleted = true
      }
      return Security.listAllUsers(req)
        .then((r) => {
          this.users = r.data.content
          return r.data.totalElements
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/user/Users.vue